import { jwtDecode } from 'jwt-decode';
import { getLastKnownAccessToken } from '../auth/authTokenProvider';

export interface ExtendedTokenPayload {
  exp?: number;
  customer_id?: string;
  role?: string;
  permission_group?: string;
  sub?: string; // Auth0 user ID
  email?: string;
  name?: string;
}

/**
 * Retrieves the user ID from the access token.
 * Falls back to customer_id if sub is not available.
 * @returns The user ID or a fallback value.
 */
export const getUserIdFromToken = (): string => {
  const token = getLastKnownAccessToken();
  if (!token) return 'unknown-user';

  try {
    const decoded = jwtDecode<ExtendedTokenPayload>(token);
    return decoded.sub || decoded.customer_id || 'unknown-user';
  } catch {
    return 'unknown-user';
  }
};
